<template>
  <div class="modal modal-sheet bg-body-primary" tabindex="-1" role="dialog">
    <div class="modal-content">
      <div class="modal-header modal-section">
        <div class="title-container">
          <!-- 使用插槽 -->
          <slot name="card-title">
            <!-- 默认标题，如果没有提供插槽内容 -->
            <h3 class="title-name">Pick one topic</h3>
          </slot>
          <slot name="card-subtitle">
            <!-- 默认副标题，如果没有提供插槽内容 -->
            <p>This will help us make classification for you</p>
          </slot>
        </div>
        <button
          type="button"
          class="btn-close"
          @click="closeModal"
          aria-label="Close"
        ></button>
      </div>
      <!-- 主体内容插槽 -->
      <div class="modal-body modal-section">
        <slot name="card-body"></slot>
        <slot name="category-editor"></slot>
        <!-- 新增插槽 -->
      </div>
      <div class="modal-footer modal-section">
        <slot name="card-footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // Your data properties
    };
  },
  methods: {
    // closeModal 方法应该在这里定义
    closeModal() {
      // 实现关闭模态的逻辑
    },
  },
};
</script>

<style scoped>
.modal-content {
  background-color: #000; /* 整体背景色 */
  background-image: url("@/assets/beginstart.svg");
  background-repeat: no-repeat;
  background-position: right 20px top -23px;
  background-size: contain; /* 或者 'cover' */
  border-radius: 10px; /* 圆角 */
  display: flex;
  flex-direction: column;
  overflow: hidden; /* 防止子元素溢出 */
  width: 650px !important; /* 增加宽度 */
  height: 450px !important; /* 增加高度 */
}

.modal-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  border: 0; /* 移除边框 */
}

.title-container {
  display: flex;
  flex-direction: column; /* 标题和副标题垂直排列 */
  margin: 20px 0px 0px 20px; /* 从两侧边缘留出一些空间 */
  align-items: flex-start; /* Aligns title to the left */
}

.btn-right {
  margin-left: auto; /* 将按钮移至右边 */
  width: 130px;
}

.modal-header .btn-close {
  border: none; /* 移除边框 */
  outline: none; /* 移除轮廓 */
}
</style>
